import React from 'react';
import { Container, Typography, useMediaQuery } from '@mui/material';
import NoAssetFound from '../../assets/images/no-asset.svg';

const Rejected = () => {
  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  return (
    <Container
      maxWidth="xl"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '80vh',
        width: !isSmallScreen ? '480px' : '100%',
        textAlign: 'center',
      }}
    >
      <div>
        <img src={NoAssetFound} alt="Rejected" />
      </div>
      <Typography variant="h4">Account update</Typography>
      <Typography color="grey" marginTop={2}>
        Thank you for signing up to our platform.
      </Typography>
      <Typography color="grey" marginTop={2}>
        We have received an enormous amount of applications for our platform and
        we continue to build on the great success we have with our beta release.
      </Typography>
      <Typography color="grey" marginTop={2}>
        We are currently onboarding a very limited number of investors on an
        invitation-only basis, and your registration has been placed to be
        included for next round of invitations.
      </Typography>
      <Typography color="grey" marginTop={2}>
        If you are having any difficulty or have any questions, please reach out
        to <a href="mailto:contact@bluesana.com.au">contact@bluesana.com.au</a>
      </Typography>
    </Container>
  );
};

export default Rejected;
